import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_base_dialog = _resolveComponent("base-dialog")!

  return (_openBlock(), _createBlock(_component_base_dialog, {
    "model-value": _ctx.modelValue,
    label: _ctx.label,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.$emit('update:modelValue', v))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        block: "",
        loading: _ctx.isExporting,
        disabled: _ctx.isImporting,
        "prepend-icon": "mdi-export",
        size: "large",
        color: "primary",
        onClick: _ctx.exportEmails
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Export ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_v_file_input, {
        modelValue: _ctx.importFile,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.importFile) = $event)),
          _ctx.importEmails
        ],
        clearable: false,
        loading: _ctx.isImporting,
        disabled: _ctx.isExporting,
        class: "mt-4",
        label: "Import",
        accept: ".xlsx",
        variant: "outlined",
        "prepend-icon": "",
        "prepend-inner-icon": "mdi-import"
      }, null, 8, ["modelValue", "loading", "disabled", "onUpdate:modelValue"])
    ]),
    _: 1
  }, 8, ["model-value", "label"]))
}